import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import StatusAlert from '@core/components/status-alert/StatusAlert.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(StatusAlert.name, StatusAlert)
